import { createSelector } from "reselect";

import { typeSelectors } from "../../../modules/definition/types";
import getDisplayItemsOfType from "./getDisplayItemsOfType";

/**
 * Get display items of all parent types (recursively)
 * @param {TimelineRecord} state
 * @param {string} typeId
 */
const getDisplayItemsOfSuperTypes = createSelector(
  // inputs
  (state, _typeId) => state,
  (_state, typeId) => typeId,
  // calculate based on inputs
  (state, typeId) => {
    const superTypes = typeSelectors.getAllSuperTypes(state, typeId);
    return superTypes.map(typeId => getDisplayItemsOfType(state, typeId)).flatten();
  }
);

export default getDisplayItemsOfSuperTypes;
